(function() {
  function qs(id){ return document.getElementById(id); }

  var cfg = qs('perso-config');
  if (!cfg) return;

  var formId = cfg.getAttribute('data-form-id');
  var form = document.getElementById(formId);
  if (!form) return;

  var persoVariantId = cfg.getAttribute('data-perso-variant-id') || '';
  var yesNo = qs('personalisation');
  var initialsWrap = qs('initials-wrapper');
  var initials = qs('initial');

  if (!yesNo) return;

  // Hidden holder for injected inputs
  var holder = document.createElement('div');
  holder.id = 'perso-hidden-holder';
  holder.style.display = 'none';
  form.appendChild(holder);

  var SCALE_WITH_QTY = true; // set false for a flat £6 per add

  function getQty() {
    var qtyInput = form.querySelector('[name="quantity"]');
    var v = parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10);
    return isNaN(v) || v < 1 ? 1 : v;
  }

  function wantsPerso() {
    return yesNo.value && yesNo.value.toLowerCase().startsWith('yes');
  }

  function toggleInitials(show) {
    if (!initialsWrap) return;
    initialsWrap.style.display = show ? '' : 'none';
    if (initials) initials.toggleAttribute('required', !!show);
  }

  function clearHidden(){ holder.innerHTML = ''; }

  function addPersoLine() {
    if (!persoVariantId) return;
    var qty = SCALE_WITH_QTY ? getQty() : 1;

    var frag = document.createDocumentFragment();

    var f1 = document.createElement('input');
    f1.type = 'hidden'; f1.name = 'items[0][id]'; f1.value = String(persoVariantId);
    frag.appendChild(f1);

    var f2 = document.createElement('input');
    f2.type = 'hidden'; f2.name = 'items[0][quantity]'; f2.value = String(qty);
    frag.appendChild(f2);

    var f3 = document.createElement('input');
    f3.type = 'hidden'; f3.name = 'items[0][properties][Type]'; f3.value = 'Personalisation add-on';
    frag.appendChild(f3);

    var f4 = document.createElement('input');
    f4.type = 'hidden'; f4.name = 'items[0][properties][Initials]'; f4.value = initials && initials.value ? initials.value : '';
    frag.appendChild(f4);

    holder.appendChild(frag);
  }

  function addMainLineProps() {
    var p1 = document.createElement('input');
    p1.type = 'hidden'; p1.name = 'properties[Personalisation]'; p1.value = wantsPerso() ? 'Yes' : 'No';
    holder.appendChild(p1);

    if (wantsPerso() && initials && initials.value) {
      var p2 = document.createElement('input');
      p2.type = 'hidden'; p2.name = 'properties[Initials]'; p2.value = initials.value;
      holder.appendChild(p2);
    }
  }

  function onYesNoChange() {
    var isYes = wantsPerso();
    toggleInitials(isYes);
    if (!isYes && initials) initials.value = '';
  }

  yesNo.addEventListener('change', onYesNoChange);
  onYesNoChange();

  // Run before Dawn's <product-form> handler so our inputs are serialized
  form.addEventListener('submit', function(e) {
    clearHidden();

    if (wantsPerso()) {
      if (!persoVariantId) {
        e.preventDefault();
        alert('Sorry — we cannot add Personalisation right now.');
        return;
      }
      if (initials && !initials.value) {
        e.preventDefault();
        initials.focus();
        alert('Please choose an initial for personalisation.');
        return;
      }
      addPersoLine();
      addMainLineProps();
    }
    // Dawn takes over: posts to /cart/add.js, shows notification, updates bubble.
  }, true);

  // --- Minimal fix for back/forward cache & section reloads ---
  window.addEventListener('pageshow', function (e) {
    if (e.persisted || (performance.getEntriesByType('navigation')[0]?.type === 'back_forward')) {
      onYesNoChange();
    }
  });

  document.addEventListener('shopify:section:load', function () {
    onYesNoChange();
  });
})();